export const TANK_SENSOR_TYPES = {
  HYDROSTATIC_BS8PT: "hydrostatic_bs8pt",
  HYDROSTATIC_BS8L1: "hydrostatic_bs8l1",
  TL_FLOAT: "tl_float",
  TL_ONLINE: "tl_online",
};

export const DEFAULT_TANK_SENSOR_TYPE = TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT;

export const TANK_SENSOR_TYPE_OPTIONS = [
  { value: TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT, label: "Hydrostatic (BS8PT)" },
  { value: TANK_SENSOR_TYPES.HYDROSTATIC_BS8L1, label: "Hydrostatic (BS8L1)" },
  { value: TANK_SENSOR_TYPES.TL_FLOAT, label: "TL_Float" },
  { value: TANK_SENSOR_TYPES.TL_ONLINE, label: "TL_Online" },
];

// Integer code sent to devices for each sensor type.
const SENSOR_TYPE_CODES = {
  [TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT]: 1,
  [TANK_SENSOR_TYPES.HYDROSTATIC_BS8L1]: 2,
  [TANK_SENSOR_TYPES.TL_FLOAT]: 3,
  [TANK_SENSOR_TYPES.TL_ONLINE]: 4,
};

// Values saved before the current option list, plus integer codes and labels.
const SENSOR_TYPE_VALUE_BY_ALIAS = {
  hydrostatic: TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT,
  hydrostatic_bs8pt_kpa: TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT,
  hydrostatic_bs8pt_bar: TANK_SENSOR_TYPES.HYDROSTATIC_BS8PT,
  hydrostatic_bs8l1_bar: TANK_SENSOR_TYPES.HYDROSTATIC_BS8L1,
  float: TANK_SENSOR_TYPES.TL_FLOAT,
  ...Object.fromEntries(
    Object.entries(SENSOR_TYPE_CODES).map(([value, code]) => [code, value]),
  ),
  ...Object.fromEntries(
    TANK_SENSOR_TYPE_OPTIONS.map((option) => [
      option.label.toLowerCase(),
      option.value,
    ]),
  ),
};

const resolveTankSensorType = (sensorType) => {
  const normalizedType = String(sensorType ?? "").trim().toLowerCase();
  if (SENSOR_TYPE_CODES[normalizedType]) return normalizedType;
  return SENSOR_TYPE_VALUE_BY_ALIAS[normalizedType] || null;
};

export const normalizeTankSensorType = (sensorType) =>
  resolveTankSensorType(sensorType) || DEFAULT_TANK_SENSOR_TYPE;

export const getTankSensorTypeCode = (sensorType) =>
  SENSOR_TYPE_CODES[normalizeTankSensorType(sensorType)];

export const getTankSensorTypeLabel = (sensorType) => {
  const resolvedType = resolveTankSensorType(sensorType);
  const option = TANK_SENSOR_TYPE_OPTIONS.find(
    (item) => item.value === resolvedType,
  );

  if (option) return option.label;
  return sensorType ? String(sensorType).replaceAll("_", " ") : "-";
};
